/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2026 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 * Marin GET /sections — get course ({@link GET_COURSE_REQUESTED}).
 *
 * @file GetCourseService.js
 */

import Framework, { BaseService } from '@greenville/framework';
import {
  GET_COURSE_REQUESTED,
  GET_COURSE_COMPLETED,
  GET_COURSE_FAILED
} from '../../../common/constants';

export default class GetCourseService extends BaseService {
  constructor() {
    super(GET_COURSE_REQUESTED, 'getCourseStatus');
  }

  /** GET /sections */
  handleEvent(eventName, eventData = {}) {
    const { copyCode, sectionId } = eventData;

    if (sectionId) {
      return this.getClient('marin').get(`/sections/${sectionId}`);
    }

    const copyCodeParam = copyCode ? `?copyCode=${copyCode}` : '';

    return this.getClient('marin').get(`/sections${copyCodeParam}`);
  }

  // eslint-disable-next-line class-methods-use-this
  handleResponse(response, eventData = {}) {
    const { data } = response;
    const { callback } = eventData;

    Framework.getEventManager().publish(GET_COURSE_COMPLETED, data);

    if (typeof callback === 'function') {
      callback(data);
    }
  }

  // eslint-disable-next-line class-methods-use-this
  handleError(error, eventData = {}) {
    const { callback } = eventData;

    Framework.getEventManager().publish(GET_COURSE_FAILED, error);

    if (typeof callback === 'function') {
      callback(null, error);
    }
  }
}
